import "./Achievements.css";
import React, { useContext } from "react";
import achievementsContext from "../../../context/achievements/achievementscontext";

function Achievements() {
  const { achievements } = useContext(achievementsContext);

  // Default stats fallback if API is empty or loading
  const statsList = achievements && achievements.length >= 4 ? achievements.map(item => ({
    val: item.count || item.title,
    label: item.description || item.sub_title
  })) : [
    { val: "90%", label: "Of deliveries here are normal, without surgical intervention" },
    { val: "2011", label: "The year Lakshmi Maternity opened on Margosa Road" },
    { val: "18 & 21", label: "Years of practice behind Dr. Nishita Rao and Dr. Mahesh B Rao" },
    { val: "24/7", label: "Labour, delivery and newborn care, on call through the night" }
  ];

  return (
    <section className="stats" id="stats">
      <div className="wrap" style={{ paddingBlock: 0 }}>
        <div className="stats-grid">
          {statsList.map((stat, idx) => (
            <div className="stat" key={idx}>
              <b>{stat.val}</b>
              <span>{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Achievements;